<section class="tabbed-detail-panel" *ngIf="hasPanel">
  <section class="global-hierarchy" *ngIf="globalHierarchyActive; else regularDetail">
    <header class="global-hierarchy__header">{{ globalHierarchyPanel?.title || 'Global Role Hierarchy' }}</header>
    <div class="global-hierarchy__body">
      <p>{{ globalHierarchyPanel?.description }}</p>
      <div class="global-hierarchy__layout">
        <div class="global-hierarchy__tree">
          <div class="global-hierarchy__node" *ngFor="let node of globalHierarchyPanel?.nodes"
            [style.margin-left.px]="(node.level || 0) * 44">
            {{ node.label }}
          </div>
        </div>
        <aside class="global-hierarchy__aside">
          <h3>{{ globalHierarchyPanel?.sideTitle }}</h3>
          <p>{{ globalHierarchyPanel?.sideDescription }}</p>
          <button type="button" *ngIf="globalHierarchyPanel?.actionLabel">{{ globalHierarchyPanel.actionLabel }}</button>
        </aside>
      </div>
    </div>
  </section>

  <ng-template #regularDetail>
  <nav class="tabbed-detail-panel__tabs" *ngIf="tabs.length">
    <button
      type="button"
      class="tabbed-detail-panel__tab"
      *ngFor="let tab of tabs"
      [class.active]="tab.key === activeTabKey"
      (click)="setActiveTab(tab.key)">
      {{ tab.label }}
    </button>
  </nav>

  <div class="tabbed-detail-panel__body" *ngIf="activePanel as panel">
    <ng-container [ngSwitch]="panel.type">
      <section class="detail-card" *ngSwitchCase="'user-assignments'">
        <header class="detail-card__header" *ngIf="panelTitle(panel)">
          {{ panelTitle(panel) }}
        </header>

        <div class="detail-card__content">
          <label class="field-group" *ngIf="currentAssignedLabel || assignedUsers">
            <span *ngIf="currentAssignedLabel">{{ currentAssignedLabel }}</span>
            <details class="assigned-users">
              <summary>{{ assignedUsers }}</summary>
              <div class="assigned-users__list">
                <div class="assigned-users__row" *ngFor="let user of assignedUserDetails">
                  <strong>{{ user.userId }}</strong>
                  <span>{{ user.email }}</span>
                </div>
                <div class="assigned-users__empty" *ngIf="!assignedUserDetails.length">
                  No users assigned
                </div>
              </div>
            </details>
          </label>

          <div class="field-group" *ngIf="userOptions.length">
            <span *ngIf="assignNewUserLabel">{{ assignNewUserLabel }}</span>
            <div class="assign-row">
              <div class="assigned-chip-list" *ngIf="assignedUserList.length">
                <span class="assigned-chip" *ngFor="let user of assignedUserList">
                  {{ user }}
                  <button
                    type="button"
                    class="assigned-chip__close"
                    [attr.aria-label]="'Remove ' + user"
                    (click)="removeAssignedUser(user)">
                    x
                  </button>
                </span>
              </div>
              <div class="assign-user-dropdown">
                <button type="button" class="assign-user-dropdown__trigger">
                  <span>{{ selectedUsersLabel }}</span>
                  <span class="assign-user-dropdown__chevron" aria-hidden="true"></span>
                </button>
                <div class="assign-user-dropdown__menu">
                  <button
                    type="button"
                    *ngFor="let option of userOptions"
                    [class.selected]="selectedUserValues.includes(option)"
                    (click)="onSelectedUserChange(option)">
                    {{ option }}
                  </button>
                </div>
              </div>
              <button type="button" class="assign-row__button" *ngIf="assignButtonLabel" (click)="assignSelectedUser()">
                {{ assignButtonLabel }}
              </button>
            </div>
          </div>

          <section class="mapping-table" *ngIf="mappings.length">
            <h3 *ngIf="mappingsTitle">{{ mappingsTitle }}</h3>
            <div class="mapping-table__scroll" *ngIf="mappingsColumns.length">
              <table>
                <thead>
                  <tr>
                    <th *ngFor="let column of mappingsColumns">{{ column.label }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let mapping of mappings">
                    <td *ngFor="let column of mappingsColumns">
                      <input
                        *ngIf="column.editable; else mappingTextCell"
                        [value]="mapping[column.key || '']"
                        (input)="onMappingEmailChange(mapping['userId'], $any($event.target).value)" />
                      <ng-template #mappingTextCell>{{ mapping[column.key || ''] }}</ng-template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <button type="button" class="mapping-table__update" *ngIf="updateMappingsLabel" (click)="updateEmailMappings()">
              {{ updateMappingsLabel }}
            </button>
          </section>
        </div>
      </section>

      <div class="permissions-view" *ngSwitchCase="'permissions'">
        <section class="permission-section" *ngFor="let section of sections; let sectionIndex = index">
          <header class="permission-section__header" *ngIf="section?.title">
            {{ section.title }}
          </header>

          <div class="permission-section__content">
            <div class="permission-card-grid" *ngIf="section?.cards?.length">
              <article
                class="permission-card"
                *ngFor="let card of section?.cards || []; let cardIndex = index"
                [class.active]="isPermissionCardSelected(sectionIndex, cardIndex)"
                role="button"
                [attr.aria-pressed]="isPermissionCardSelected(sectionIndex, cardIndex)"
                tabindex="0"
                (click)="togglePermissionCard(sectionIndex, cardIndex)"
                (keydown)="onPermissionCardKeydown($event, sectionIndex, cardIndex)">
                <div class="permission-card__content">
                  <strong>{{ card.title }}</strong>
                  <p>{{ card.description }}</p>
                </div>
                <span class="permission-card__switch" aria-hidden="true">
                  <span class="permission-card__switch-knob"></span>
                </span>
              </article>
            </div>

            <table class="permission-table" *ngIf="section?.table as table">
              <thead>
                <tr>
                  <th *ngFor="let column of table.columns || []">{{ column.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of table.rows || []; let rowIndex = index">
                  <td *ngFor="let column of table.columns || []">
                    <input
                      *ngIf="column.type === 'checkbox'; else textCell"
                      type="checkbox"
                      [checked]="isPermissionChecked(row, sectionIndex, rowIndex, column.key)"
                      (change)="togglePermissionCheck(row, sectionIndex, rowIndex, column.key)" />
                    <ng-template #textCell>{{ row[column.key || ''] }}</ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <section class="detail-card" *ngSwitchDefault>
        <header class="detail-card__header" *ngIf="panelTitle(panel)">
          {{ panelTitle(panel) }}
        </header>
      </section>
    </ng-container>
  </div>
  </ng-template>

  <div class="toast" [class.visible]="toastVisible" role="status" aria-live="polite">
    {{ toastMessage }}
  </div>
</section>
